const Colors = () => {
  const primary = '#92D14E'
  const secondary = '#535353'
  const backgroundBroker = '#EFEFEF'
  return {
    primary,
    secondary,
    backgroundBroker,
    drawerBase: primary,
    text: '#202124',
    black: '#000',
    white: '#fff',
    darkGrey: '#7e7e7e',
    grey: ['#e3e3e3', '#EEEEEF', '#bfbfbf', '#fcfcfc', '#f7f7f7'],
    blue: ['#012060', '#006BC6'],
    green: ['#d6edd3', '#a9cca5', '#8abe87'],
    warning: ['#DFA800', '#FCBF00'],
    muted: '#848484',
    inputDisabled: 'rgba(0, 0, 0, 0.38)',
    backdrop: 'rgba(0,0,0,0.5)',
    orange: ['#ff6c5c', '#c63a2d']
  }
}

export default Colors()
